import type { DashboardSummary } from '../types/dashboard';
import { request } from './apiClient';

export function getDashboardSummary(): Promise<DashboardSummary> {
  return request<DashboardSummary>('/api/dashboard');
}
